export default __webpack_public_path__ + "static/media/scanner-overlay.b333ffe6.svg";